import * as angular from 'angular';
import { StateService } from '@uirouter/core';
import { IRouteState } from './models';

export class PreviousStateService {
    static $inject = ['$state', '$q'];

    private value: IRouteState;

    constructor(
        private $state: StateService,
        private $q: ng.IQService
    ) { }

    go() {
        var previous = this.value;
        if (previous && !previous.state.abstract) {
            return this.$state.go(previous.state, previous.params);
        } else {
            return this.$q.reject();
        }
    }

    get(): IRouteState {
        return this.value;
    }

    set(value: IRouteState) {
        this.value = value;
    }
}

angular.module('app.common').service('$previousState', PreviousStateService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/routes/previous-state.service.ts